import styled from 'styled-components';

import { colors, typography } from '../../../../styles/tokens';
import { PillButton } from '../../../../components/PillButton';

export const Grid = styled.div`
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(min(100%, 320px), 1fr));
  gap: 22px;
  align-items: stretch;
`;

export const PlanCard = styled.div<{ highlighted?: boolean }>`
  height: 100%;
  border-radius: 34px;
  padding: 32px;
  display: flex;
  flex-direction: column;
  gap: 22px;

  border: 1px solid
    ${props => (props.highlighted ? colors.primary : colors.border)};
  background: ${props =>
    props.highlighted
      ? `linear-gradient(180deg, ${colors.surfaceHighlight} 0%, ${colors.surface} 100%)`
      : colors.surface};
  box-shadow: ${props =>
    props.highlighted ? '0 24px 60px rgba(255, 140, 85, 0.14)' : 'none'};
`;

export const PlanHeader = styled.div`
  display: flex;
  flex-wrap: wrap;
  gap: 10px;
  align-items: center;
`;

export const PlanName = styled.span`
  font-family: ${typography.displayFontFamily};
  font-weight: 700;
  font-size: 20px;
  color: ${colors.textPrimary};
`;

export const PopularTag = styled.span`
  padding: 5px 11px;
  border-radius: 999px;
  background: ${colors.primary};
  color: ${colors.onPrimary};
  font-size: 11px;
  font-weight: 800;
  letter-spacing: 0.1em;
  text-transform: uppercase;
`;

export const PlanSubtitle = styled.p<{ highlighted?: boolean }>`
  margin: 8px 0 0;
  font-size: 15px;
  line-height: 1.55;
  color: ${props =>
    props.highlighted ? colors.textSecondary : colors.textMuted};
`;

export const PriceRow = styled.div`
  display: flex;
  align-items: baseline;
  gap: 6px;
`;

export const Price = styled.span`
  font-family: ${typography.displayFontFamily};
  font-weight: 800;
  font-size: 42px;
  color: ${colors.textPrimary};
`;

export const PricePeriod = styled.span<{ highlighted?: boolean }>`
  font-size: 15px;
  font-weight: 600;
  color: ${props => (props.highlighted ? colors.textMuted : colors.textFaint)};
`;

export const PlanNoteLabel = styled.div<{ highlighted?: boolean }>`
  font-size: 13px;
  font-weight: 700;
  letter-spacing: 0.08em;
  text-transform: uppercase;
  color: ${props => (props.highlighted ? colors.primary : colors.textFaint)};
  margin-bottom: 12px;
`;

export const Features = styled.ul<{ highlighted?: boolean }>`
  margin: 0;
  padding: 0;
  list-style: none;
  display: grid;
  gap: 11px;
  font-size: 15px;
  line-height: 1.45;
  color: ${colors.textSecondary};

  li {
    display: grid;
    grid-template-columns: 16px 1fr;
    gap: 10px;
  }

  span:first-child {
    color: ${colors.primary};
  }
`;

export const PlanCta = styled(PillButton)`
  width: 100%;
  justify-content: center;
  margin-top: auto;
`;

export const Footnote = styled.p`
  margin: 24px 0 0;
  font-size: 14px;
  line-height: 1.6;
  color: ${colors.textFaintest};
`;

export const ComparisonWrapper = styled.div`
  margin-top: 56px;
  border-radius: 30px;
  border: 1px solid ${colors.border};
  background: ${colors.surface};
  overflow-x: auto;
`;

export const ComparisonTable = styled.table`
  width: 100%;
  min-width: 680px;
  border-collapse: collapse;
  font-size: 15px;
`;

export const Th = styled.th<{ highlight?: boolean }>`
  text-align: center;
  padding: 20px 16px;
  border-bottom: 1px solid ${colors.border};
  font-family: ${typography.displayFontFamily};
  font-weight: 600;
  color: ${props => (props.highlight ? colors.primary : colors.textSecondary)};

  small {
    display: block;
    margin-top: 4px;
    font-size: 13px;
    font-weight: 600;
    font-family: ${typography.fontFamily};
    color: ${props =>
      props.highlight ? colors.textSecondary : colors.textFaint};
  }
`;

export const ThLabel = styled.th`
  text-align: left;
  padding: 20px 24px;
  color: ${colors.textFaint};
  font-size: 12px;
  letter-spacing: 0.12em;
  text-transform: uppercase;
  font-weight: 700;
  border-bottom: 1px solid ${colors.border};
`;

export const Td = styled.td<{ center?: boolean }>`
  padding: ${props => (props.center ? '16px' : '16px 24px')};
  text-align: ${props => (props.center ? 'center' : 'left')};
  color: ${colors.textSecondary};
  border-bottom: 1px solid ${colors.borderSubtle};
`;

export const CheckCell = styled.td<{ checked?: boolean }>`
  padding: 16px;
  text-align: center;
  border-bottom: 1px solid ${colors.borderSubtle};
  color: ${props => (props.checked ? colors.primary : colors.textOff)};
`;
